export const SOCKET_MSG_TYPE = {
    USER_LIST_ON_MIC: 'base-onmic-users', // 在麦用户列表
    USER_PUBLISHED: 'user-published', // 流发布
    USER_UNPUBLISHED: 'user-unpublished', // 取消流发布
    USER_UPDATE: 'base-onmic-users-updated', // 用户变更
    LIVE_STATUS_UPDATE: 'base-live-status-updated', // 直播状态变更
    LAST_INFO_DETAIL: 'base-action-info', // 终端快照
    VOLUME_INDICATOR: 'volume-indicator', // 流音量变化
    DEVICE_LIST_ACK: 'device-list-ack', // 客户端发送设备列表
    BASE_LIVE_INFO: 'base-live-info', // 直播基本信息
    LIVE_INFO_UPDATE: 'base-live-info-updated',  // 直播信息变更
    LAYOUT_CHANGE: 'layoutchange',  // 导播台布局变化
    REMOTE_CONTROL: 'remote-control', // 远程控制
    ENABLED_AUTO_CASTER: 'enabled-auto-caster',  // 开启自动导播
    DISABLED_AUTO_CASTER: 'disabled-auto-caster',  // 关闭自动导播
    NICKNAME_CHANGE: 'nickname-change',  // 昵称变化
	ENABLED_DEVICE: 'enabled-device', // 开启设备
	DISABLED_DEVICE: 'disabled-device', // 禁用设备
    STREAM_CHANGED: 'user-stream-changed', // 流变更
    OPEN_SCREEN: 'open-screen', // 共享屏幕
	STOP_SCREEN: 'stop-screen' // 停止共享屏幕
}